import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import { MaplatUi } from "../src";
import "../less/ui.less";
var Maplat = window.Maplat = {};
Maplat.createObject = function (option) {
  return new Promise(function (resolve) {
    var app = new MaplatUi(option);
    app.waitReady.then(function () {
      resolve(app);
    });
  });
};